const e = Symbol("onMirrorCreated"), i = Symbol("onMirrorDestroy"), g = {
  duration: 100,
  easingFunction: "ease-in-out"
};
function h({ mirror: t, original: s, classes: n }) {
  t && t.parentNode && (t.removeEventListener("transitionend", h), t.parentNode.removeChild(t)), s.classList.remove(n["source:dragging"]);
}
function p(t, s, { x: n, y: o }, { duration: a, easingFunction: r }, d) {
  s.classList.add(d["source:dragging"]);
  const { m41: l, m42: c } = new DOMMatrix(t.style.transform), m = Math.round(Math.hypot(l - n, c - o) * 0.8);
  a = Math.max(m, 80), requestAnimationFrame(() => {
    t.addEventListener("transitionend", h.bind(this, { mirror: t, original: s, classes: d })), t.style.transition = `transform ${a}ms ${r}, box-shadow ${a}ms ${r}`, t.style.transform = `translate3d(${n}px, ${o}px, 0)`, t.style.boxShadow = "0px 0px 0px rgba(0, 0, 0, 0.17)";
  });
}
class u {
  constructor(s) {
    this.draggable = s, this.options = {
      ...g,
      ...this.getOptions()
    }, this.classes = {
      ...this.draggable.options.classes
    }, this.lastAnimationFrame = null, this[i] = this[i].bind(this), this[e] = this[e].bind(this);
  }
  attach() {
    this.draggable.on("mirror:created", this[e]).on("mirror:destroy", this[i]);
  }
  detach() {
    this.draggable.off("mirror:created", this[e]).off("mirror:destroy", this[i]);
  }
  getOptions() {
    return this.draggable.options.placeAnimation || {};
  }
  [e]({ mirror: s }) {
    requestAnimationFrame(() => {
      s.style.transition = `box-shadow ${this.options.duration}ms ${this.options.easingFunction}`, s.style.boxShadow = "0px 10px 16px rgba(0, 0, 0, 0.17)";
    });
  }
  [i](s) {
    s.cancel();
    const {
      dragEvent: {
        data: { originalSource: n, source: o }
      },
      mirror: a
    } = s.data, { x: r, y: d } = o.getBoundingClientRect();
    cancelAnimationFrame(this.lastAnimationFrame), this.lastAnimationFrame = requestAnimationFrame(() => {
      p(a, n, { x: r, y: d }, this.options, this.classes);
    });
  }
}
export {
  u as default,
  g as defaultOptions
};
//# sourceMappingURL=place-animation.js.map
